<template lang='pug'>
  div
    v-toolbar(dense)
      v-tooltip(right)
        template(v-slot:activator='{on}')
          v-btn(v-on='on' @click='goBack' text icon)
            v-icon arrow_back
        span Back to Users
    bionic-metrics-page-loading(v-if='loading')
    v-container(fluid v-if='!loading && user')
      v-form(ref='userForm' v-model='userFormValid')
        v-card.mb-2
          v-card-title
            v-col.pa-0(v-if='user')
              .text-h5.font-weight-light User Details
              .text-caption.font-weight-light ID: {{user._id}}
              .text-caption.font-weight-light Account: {{user.account.name}}
          v-card-text
            v-text-field#firstName(label='First Name' v-model='user.firstName' required :rules='required' @input='triggerSave')
            v-text-field#lastName(label='Last Name' v-model='user.lastName' required :rules='required' @input='triggerSave')
            v-text-field#email(label='Email' v-model='user.email' required :rules='required' @input='triggerSave')
            v-checkbox#enabled(label='Enabled'
              v-model='user.enabled'
              @change='triggerSave'
              persistent-hint
              hint='Check to enable/disable this user')
</template>

<script>
import {mapGetters} from 'vuex';
import SuperAdmin from '@/api/superAdmin';
import Notifications from '@/services/notification.service';
import BionicMetricsPageLoading from '@/components/PageLoading';
import SaveMixin from '@/mixins/save.mixin';

export default {
  name: 'SuperAdminUserEdit',
  components: {BionicMetricsPageLoading},
  mixins: [SaveMixin],
  props: ['id'],
  async mounted() {
    if (!this.id) {
      return this.$router.push('/super/users');
    }
    await this.load();
  },
  computed: {
    saveObject() {
      return this.user;
    },
    ...mapGetters({
      activeUser: 'getUser'
    })
  },
  methods: {
    async load() {
      try {
        this.loading = true;
        this.user = await SuperAdmin.getUser(this.id);
      } catch (error) {
        Notifications.alertError('Unable to fetch user details', error);
        this.$router.push('/super/users');
      } finally {
        this.loading = false;
      }
    },
    to(route) {
      this.$router.push(route);
    },
    goBack() {
      this.$router.go(-1);
    },
    async showFormErrors() {
      await Notifications.toast('This form has invalid fields. Please check the form and try again.');
      this.$refs.userForm.validate();
    },
    async save() {
      if (!this.userFormValid) return this.showFormErrors();
      this.updating = true;
      try {
        await SuperAdmin.editUser(this.user._id, this.user);
        Notifications.toast(`<strong>${this.user.email}</strong> updated.`);
      } catch (error) {
        console.error(error);
        Notifications.errorToast('There was a problem saving the user', {duration: 5000});
      } finally {
        this.updating = false;
        this.dirty = false;
      }
    }
  },
  data() {
    return {
      user: null,
      loading: false,
      updating: false,
      userFormValid: false,
      required: [
        (v) => !!v || 'This is a required field'
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
